import { AnyAction } from 'redux'
import { StationState } from './types/reducerTypes'

const defaultState: StationState = {
  call_sign: '',
  passportEligible: false,
  station_id: '',
  station_title: '',
  black_logo: '',
  color_logo: '',
  station_scenery: null,
  white_logo: '',
  white_cobranded_logo: '',
  white_single_logo: '',
  short_common_name: '',
  passport_learn_more_url: '',
  showMenu: null,
  donation_campaign: {
    id: '',
    minimum_amount: '',
    minimum_monthly_amount: '',
    monthly_amount_options: [],
    onetime_amount_options: [],
    station_has_donation_campaign: false,
    pre_donation_copy: ''
  },
  fallback_station: {
    callsign: '',
    cid: '',
    city: '',
    fullName: '',
    shortName: '',
  },
  localize_station_step: 0,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'UPDATE_STATION':
      return { ...state, ...action.payload }
    case 'UPDATE_DONATION_CAMPAIGN':
      return { ...state, donation_campaign: { ...action.payload } }
    case 'UPDATE_FALLBACK_STATION':
      return { ...state, fallback_station: { ...action.payload } }
    case 'UPDATE_LOCALIZATION_STEP':
      return { ...state, localize_station_step: action.payload }
    default:
      return state
  }
}
